import React from 'react';
import clsx from 'clsx';
import Info from 'components/shared/Info';
import styles from './Switch.module.scss';
import Preloader from '../Preloader';
import { useTranslation } from 'react-i18next';

function Switch({
  title, value, onChange, isPanel, infoMessage, className, icon, disabled, loading,
}: {
  title: string,
  value?: boolean,
  isPanel?: boolean,
  onChange: (v: boolean) => void,
  infoMessage?: React.ReactNode,
  className?: string,
  icon?: React.ReactNode,
  disabled?: boolean,
  loading?: boolean
}) {

  const {t} = useTranslation() as any;
  return (
    <div
      className={clsx(
        styles.container,
        className,
        isPanel && styles.containerPanel,
      )}
    >
      <Info
        className={styles.title}
        infoMessage={infoMessage}
        icon={icon}
      >
        {t(title)}
      </Info>
      {loading ? (
        <div className={styles.loader}>
          <Preloader />
        </div>
      ) : (
        <div
          className={clsx(styles.swithInput, value && styles.swithInputOn)}
          onClick={() => { if (!disabled) onChange(true) }}
        />
      )}
    </div>
  )
}
export default Switch
